import React from "react";
import {
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";

const SocialShare = [
  { Social: <FaFacebookF />, link: "https://www.facebook.com/ActivoDigitalMx/", label: "Facebook" },
  { Social: <FaInstagram />, link: "https://www.instagram.com/activodigitalmx/", label: "Instagram" },
];

const Social = () => {
  return (
    <div className="nav social-icons social-icons-two justify-content-center">
      {SocialShare.map((val, i) => (
        <a key={i} href={`${val.link}`} rel="noreferrer" target="_blank" aria-label={val.label}>
          {val.Social}
        </a>
      ))}
    </div>
  );
};

export default Social;
